import React, { useCallback, useMemo, useState } from 'react';
import './mediaHotspotLine.scss';
import { createPortal } from 'react-dom';
import { useClickOutside } from 'common/hooks';
import { GalleryIcon, VideoIcon } from 'assets/icons';
import { useTranslation } from 'react-i18next';
import { trackTourContentOpen } from 'gaTracking';

const DEFAULT_HEIGHT = 140;

const MediaHotspot = ({
  media,
  height,
  goToScene,
  handleApartmentPopup,
  tour,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleOpenMediaPopup = useCallback(() => {
    setOpen(true);
    trackTourContentOpen({
      media_id: media._id,
      tour_id: tour.id,
    });
  }, [media._id, tour.id]);

  const contents = useMemo(() => {
    const res = [];
    const title = media.title || '';
    if (title && title !== '.') {
      res.push(title);
    }
    const description = (media.infoTag?.text || '').split('\n');
    res.push(...description);
    return res;
  }, [media]);

  const imgUrl = useMemo(() => {
    if (media.type === 'Image') {
      return media.imageURL;
    }
    return null;
  }, [media]);

  const isSalesGallery = useMemo(() => media.id === 'sales-gallery', [media]);

  const getContainerHeight = useMemo(() => {
    const heightMap = {
      'TP. Tân An': '110px',
      'KCN Tân Đức': '90px',
      'Water Point Nam Long': '150px',
      'Vinhome Green City': '130px',
      'Aeon Mall Bình Tân': '150px',
      'Bệnh viện Nhi Đồng 2': '110px',
      'Trường ĐH Tân Tạo': '40px',
      LAHOME: '60px',
      'KCN Idico Hựu Thạnh': '90px',
      'CV Võ Văn Tần': '40px',
      'Chợ Cầu Xáng': '50px',
      'Bệnh viện ĐH Y Tân Tạo': '60px',
      'Bến xe Miền Tây': '100px',
    };

    for (const text of contents) {
      if (text && heightMap[text.trim()]) {
        return heightMap[text.trim()];
      }
    }

    if (height) {
      return `${height * 50}px`;
    }

    return '75px';
  }, [contents, height]);

  const onHover = () => {};

  const handleClick = useCallback(() => {
    if (isSalesGallery) {
      // goToScene('can-ho-mau', '2');
      handleApartmentPopup();
    }
  }, [isSalesGallery, handleApartmentPopup]);

  if (media.type === 'Gallery' || media.type === 'Video') {
    const effectiveHeight = DEFAULT_HEIGHT;
    return (
      <>
        <div className="media-outdoor--hotspot-style">
          <div
            className="media-outdoor--hotspot-style--container"
            style={{
              height: `${effectiveHeight * (media?.height || height)}px`,
            }}
          >
            <div className="media-outdoor--hotspot-style--line"></div>
            <div
              className={`media-outdoor--hotspot-style--title `}
              onClick={handleOpenMediaPopup}
            >
              <div className="media-outdoor--hotspot-style--title-icon">
                <div className="media-outdoor--hotspot-style--title-icon-circle">
                  {media.type === 'Gallery' ? (
                    <GalleryIcon size={18} color="#a0793c" />
                  ) : (
                    <VideoIcon size={20} color="#a0793c" />
                  )}
                </div>
              </div>
              <div className="media-outdoor--hotspot-style--title-texts">
                <div className="media-outdoor--hotspot-style--title-text">
                  {t(media.title)}
                </div>
              </div>
              {/* {scene?.amenitiesScene && scene?.previewImgUrl && (
              <div
                className={`ntv-outdoor--hotspot-style--preview ${
                  darkStyle ? 'is-hidden' : ''
                }`}
              >
                <img src={scene?.previewImgUrl} alt="preview" />
              </div>
            )} */}
            </div>
          </div>
        </div>
        {open &&
          createPortal(
            <div className="media-popup-container">
              <div className="popup-content">
                <p>{media.title}</p>
                <Popup media={media} onClose={() => setOpen(false)} />
              </div>
            </div>,
            document.body
          )}
      </>
    );
  }

  return (
    <>
      <div
        className={`khp-media-hotspot ${media.type} ${
          isSalesGallery ? 'big-bottom' : ''
        }`}
        onMouseEnter={onHover}
        onClick={handleClick}
      >
        <div
          className="khp-media-hotspot__container"
          style={{ height: getContainerHeight }}
        >
          <div className="khp-media-hotspot__title bcons-text">
            {contents.map((txt, index) => (
              <p key={index} className={contents.length > 2 ? 'text-left' : ''}>
                {txt}
              </p>
            ))}
            {imgUrl && (
              <img
                className="khp-media-hotspot__preview"
                src={imgUrl}
                alt={media.title}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MediaHotspot;

const Popup = ({ media, onClose }) => {
  const mainRef = useClickOutside(() => {
    onClose();
  }, []);

  console.log('media in popup', media);
  return (
    <div className="media-popup-container">
      <div className="popup-content" ref={mainRef}>
        {media.type === 'Gallery' && (
          <img src={media.gallery[0].imageUrl} alt="Gallery popup hotspot" />
        )}

        {media.type === 'Video' && (
          <iframe
            width="800"
            height="800"
            src={media.video.videoUrl ?? ''}
            title="Architectural animation for the office building in Australia|3D Visualization for Fenders Katsalidis"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          />
        )}
      </div>
    </div>
  );
};
